import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUpFill = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "currentColor", viewBox: "0 0 17 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.416 10c-.891 0-1.338-1.077-.708-1.707l2.586-2.586a1 1 0 0 1 1.414 0l2.586 2.586c.63.63.184 1.707-.707 1.707H5.416Z" }));
const ForwardRef = forwardRef(SvgChevronUpFill);
export default ForwardRef;
